
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutaFSLMCpkfpOsvMGJQaPmi3LlCxOdQWgIn6bSUuAOquEMeta } from "D:/.jenkins/workspace/web-prod-xkira-official-website/pages/about.vue?macro=true";
import { default as indexIO4UJt0AEKk_45vFiOZx5I41d8rh9pwv8b2O9mwSrwGnkMeta } from "D:/.jenkins/workspace/web-prod-xkira-official-website/pages/index.vue?macro=true";
import { default as homeH531c92T_45rAed2f9dblgcR7Dpk5nEI_jPJjrCUiY5ABjcMeta } from "D:/.jenkins/workspace/web-prod-xkira-official-website/pages/homeH5.vue?macro=true";
import { default as productHa9WB8NEE8qsVxlhPhn_4518VhBm3ezfFjgUZHgHpoOEAMeta } from "D:/.jenkins/workspace/web-prod-xkira-official-website/pages/product.vue?macro=true";
import { default as downloadw7VA1I0mFwYNXZVQD6BtdLjHDH022ZbOnZh0o5Ngz2kMeta } from "D:/.jenkins/workspace/web-prod-xkira-official-website/pages/download.vue?macro=true";
import { default as downloadH57DhK81HH5TDotOUeibjI8ZtZxbjlJicB7EDpkmpDD4oMeta } from "D:/.jenkins/workspace/web-prod-xkira-official-website/pages/downloadH5.vue?macro=true";
import { default as privacyPolicymZ3JaN_JgkbafU_45lvDfstCWKWpdf6RQkXHqPzaKK8KsMeta } from "D:/.jenkins/workspace/web-prod-xkira-official-website/pages/privacyPolicy.vue?macro=true";
import { default as userAgreement7w0R0rYDYcpy_45X5Qf4y8RMpqrbJfpVx1S6mqnoDliBcMeta } from "D:/.jenkins/workspace/web-prod-xkira-official-website/pages/userAgreement.vue?macro=true";
import { default as softwareAgreementr8sc2C24JwFZ3fIfQ3Mlt1gDxXG7RWPrtYaxslqh0gQMeta } from "D:/.jenkins/workspace/web-prod-xkira-official-website/pages/softwareAgreement.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    meta: aboutaFSLMCpkfpOsvMGJQaPmi3LlCxOdQWgIn6bSUuAOquEMeta || {},
    component: () => import("D:/.jenkins/workspace/web-prod-xkira-official-website/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("D:/.jenkins/workspace/web-prod-xkira-official-website/pages/index.vue")
  },
  {
    name: "homeH5",
    path: "/homeH5",
    component: () => import("D:/.jenkins/workspace/web-prod-xkira-official-website/pages/homeH5.vue")
  },
  {
    name: "product",
    path: "/product",
    meta: productHa9WB8NEE8qsVxlhPhn_4518VhBm3ezfFjgUZHgHpoOEAMeta || {},
    component: () => import("D:/.jenkins/workspace/web-prod-xkira-official-website/pages/product.vue")
  },
  {
    name: "download",
    path: "/download",
    meta: downloadw7VA1I0mFwYNXZVQD6BtdLjHDH022ZbOnZh0o5Ngz2kMeta || {},
    component: () => import("D:/.jenkins/workspace/web-prod-xkira-official-website/pages/download.vue")
  },
  {
    name: "downloadH5",
    path: "/downloadH5",
    meta: downloadH57DhK81HH5TDotOUeibjI8ZtZxbjlJicB7EDpkmpDD4oMeta || {},
    component: () => import("D:/.jenkins/workspace/web-prod-xkira-official-website/pages/downloadH5.vue")
  },
  {
    name: "privacyPolicy",
    path: "/privacyPolicy",
    meta: privacyPolicymZ3JaN_JgkbafU_45lvDfstCWKWpdf6RQkXHqPzaKK8KsMeta || {},
    component: () => import("D:/.jenkins/workspace/web-prod-xkira-official-website/pages/privacyPolicy.vue")
  },
  {
    name: "userAgreement",
    path: "/userAgreement",
    meta: userAgreement7w0R0rYDYcpy_45X5Qf4y8RMpqrbJfpVx1S6mqnoDliBcMeta || {},
    component: () => import("D:/.jenkins/workspace/web-prod-xkira-official-website/pages/userAgreement.vue")
  },
  {
    name: "softwareAgreement",
    path: "/softwareAgreement",
    meta: softwareAgreementr8sc2C24JwFZ3fIfQ3Mlt1gDxXG7RWPrtYaxslqh0gQMeta || {},
    component: () => import("D:/.jenkins/workspace/web-prod-xkira-official-website/pages/softwareAgreement.vue")
  }
]